module.exports = __webpack_public_path__ + "static/media/LUP_zast_L4.9afd3411.svg";